import Image from '@/shared/ui/AppImage'
import { AppIcon  } from '@/shared/ui/icons'

import _ from 'lodash'

import { truncateName } from '@/shared/lib/string/truncate-name'
import { Avatar } from '@/shared/ui/Avatar'

export const InsightsPointsRankingTopWidget = ({
  rank,
  me,
  user_progress,
  whiteRanking = false,
  points,
  size = 'lg',
  className = '',
  ...rest
}) => {
  const user = user_progress?.user

  if (size === 'sm') {
    return (
      <div
        className={`flex items-center justify-start gap-4 bg-white rounded-2xl py-3 px-5 lg:py-4 lg:px-6 ${
          me ? 'border-b-[3px] border-brand' : ''
        }`}
      >
        <span className="text-sm font-bold block w-[15px] text-center text-gray-600">
          {rank}
        </span>
        <div className="aspect-square w-[40px] h-[40px]">
          {user_progress?.avatar && !_.isEmpty(user_progress?.avatar) ? (
            <div className="rounded-full w-[40px] h-[40px] overflow-hidden">
              <Avatar config={user_progress?.avatar} />
            </div>
          ) : (
            <Image
              src={_.get(user, 'avatar.file.url', '/placeholders/user.svg')}
              width={200}
              height={200}
              className="rounded-full object-cover object-center"
              alt={user?.name || ''}
            />
          )}
        </div>
        <span className="block text-xs text-center font-bold text-gray-800">
          {_.startCase(_.toLower(truncateName(user?.name || '', 20)))}{' '}
          {me && <span className="text-gray-500">(eu)</span>}
        </span>
        <span className="block text-center text-sm text-amber-500 font-semibold ml-auto">
          {points} XP
        </span>
      </div>
    )
  }

  return (
    <div
      className={`w-full p-2 z-[1] relative ${className}`}
      {...rest}
    >
      <div className="flex flex-col items-center justify-center">
        {rank == 1 ? (
          <AppIcon  name="crown" className="text-amber-500 text-xl mb-3"  />
        ) : (
          <span
            className={`text-center text-sm font-extrabold ${
              whiteRanking ? 'text-white' : 'text-gray-600'
            } block w-full`}
          >
            {rank}
          </span>
        )}
        {rank == 2 && (
          <AppIcon
            name="caret-up"
            className={whiteRanking ? 'text-white' : 'text-gray-400'}
          />
        )}
        {rank == 3 && (
          <AppIcon  name="caret-down"
            style={{ color: whiteRanking ? '#fff' : '#9B7A01' }}
           />
        )}
      </div>
      <div className={`${rank == 1 ? 'mb-4' : 'mb-2'}`}>
        <div className="aspect-square">
          {user_progress?.avatar && !_.isEmpty(user_progress?.avatar) ? (
            <div className="rounded-full border-4 border-white bg-white shadow-sm overflow-hidden">
              <Avatar config={user_progress?.avatar} />
            </div>
          ) : (
            <Image
              src={_.get(user, 'avatar.file.url', '/placeholders/user.svg')}
              width={200}
              height={200}
              className="w-full rounded-full border-4 border-white bg-white shadow-sm object-cover object-center"
              alt={user?.name || ''}
              style={{
                transform: rank === 1 ? 'scale(1)' : 'scale(0.9)'
              }}
            />
          )}
        </div>
      </div>
      <div
        className={`bg-white rounded-md pb-2 pt-3 px-2 border-b-2 ${
          me ? ' border-brand' : ' border-gray-100'
        }`}
      >
        <span className="block w-full text-center text-amber-500 font-semibold text-sm leading-none">
          {points} XP
        </span>
        <span className="block w-full text-center font-bold text-gray-800 text-2xs">
          {_.startCase(_.toLower(truncateName(user?.name || '', 18)))}{' '}
          {me && <span className="text-gray-500">(eu)</span>}
        </span>
      </div>
    </div>
  )
}
